


















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ForgotPasswordImageLink extends Vue {
  @Prop({ required: true })
  readonly forgotPasswordRoute: string
}
